export default __webpack_public_path__ + "static/media/Dinner.3cd8b4df.svg";